import { render } from "./Market.index.vue?vue&type=template&id=45f2c3c8&scoped=true&ts=true"
import script from "./Market.index.vue?vue&type=script&lang=ts"
export * from "./Market.index.vue?vue&type=script&lang=ts"

import "./Market.index.vue?vue&type=style&index=0&id=45f2c3c8&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f2c3c8"]])

export default __exports__